import { cn } from "@shared/lib/utils";

type StatusType =
  | "pending"
  | "Started"
  | "completed"
  | "failed"
  | "warning"
  | "success"
  | "info"; // Added "info" status type

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
  className?: string;
}

const statusConfig = {
  pending: {
    class: "bg-muted text-muted-foreground",
    defaultLabel: "Pending",
  },
  Started: {
    class: "bg-info/20 text-info border border-info/50",
    defaultLabel: "In Progress",
  },
  completed: {
    class: "bg-success/20 text-success border border-success/50",
    defaultLabel: "Completed",
  },
  failed: {
    class: "bg-destructive/20 text-destructive border border-destructive/50",
    defaultLabel: "Failed",
  },
  warning: {
    class: "bg-warning/20 text-warning border border-warning/50",
    defaultLabel: "Warning",
  },
  success: {
    class: "bg-success/20 text-success border border-success/50",
    defaultLabel: "Success",
  },
  info: {
    // Added configuration for "info" status
    class: "bg-primary/20 text-primary border border-primary/50",
    defaultLabel: "Info",
  },
};

export function StatusBadge({ status, label, className }: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
        config.class,
        className
      )}
    >
      {label || config.defaultLabel}
    </span>
  );
}
